<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="switchCouponStatus({ label: $t('platformCoupon.all'), value: '' })"
              :class="{ 'selected': couponManageInfo.conditions.statusCd === '' }">
              {{ $t('platformCoupon.all') }}
            </li>
            <li @click="switchCouponStatus({ label: $t('platformCoupon.onShelfStatus'), value: '0' })"
              :class="{ 'selected': couponManageInfo.conditions.statusCd === '0' }">
              {{ $t('platformCoupon.onShelfStatus') }}
            </li>
            <li @click="switchCouponStatus({ label: $t('platformCoupon.offShelfStatus'), value: '1' })"
              :class="{ 'selected': couponManageInfo.conditions.statusCd === '1' }">
              {{ $t('platformCoupon.offShelfStatus') }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('platformCoupon.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="couponManageInfo.conditions.couponName"
                :placeholder="$t('platformCoupon.selectCouponName')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="couponManageInfo.conditions.couponType" clearable
                :placeholder="$t('platformCoupon.selectCouponType')" style="width:200px">
                <el-option :label="$t('platformCoupon.fullReduction')" value="01" />
                <el-option :label="$t('platformCoupon.discount')" value="02" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryCouponMethod()">
                <i class="el-icon-search"></i> {{ $t('platformCoupon.query') }}
              </el-button>
              <el-button @click="_resetCouponMethod()">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('platformCoupon.coupons') }}</span>
            <el-button type="primary" size="small" @click="_openAddCouponModal()">
              {{ $t('platformCoupon.add') }}
            </el-button>
          </div>
          <el-table :data="couponManageInfo.coupons" border style="width:100%" v-loading="loading">
            <el-table-column prop="couponCode" :label="$t('platformCoupon.couponCode')" align="center" />
            <el-table-column prop="couponName" :label="$t('platformCoupon.couponName')" align="center" />
            <el-table-column prop="couponType" :label="$t('platformCoupon.couponType')" align="center">
              <template slot-scope="scope">
                {{ scope.row.couponType === '01' ? $t('platformCoupon.fullReduction') : $t('platformCoupon.discount') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('platformCoupon.discountInfo')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.couponType === '01'">
                  {{ $t('platformCoupon.reduce') }}￥{{ scope.row.discountAmount }}
                </span>
                <span v-else>
                  {{ scope.row.discountPercent }}%{{ $t('platformCoupon.off') }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="minAmount" :label="$t('platformCoupon.minAmount')" align="center">
              <template slot-scope="scope">
                ￥{{ scope.row.minAmount }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('platformCoupon.scope')" align="center">
              {{ $t('platformCoupon.allScope') }}
            </el-table-column>
            <el-table-column prop="totalQuantity" :label="$t('platformCoupon.totalQuantity')" align="center" />
            <el-table-column prop="receivedCount" :label="$t('platformCoupon.receivedCount')" align="center" />
            <el-table-column prop="usedCount" :label="$t('platformCoupon.usedCount')" align="center" />
            <el-table-column prop="statusCd" :label="$t('platformCoupon.status')" align="center">
              <template slot-scope="scope">
                {{ scope.row.statusCd === '0' ? $t('platformCoupon.onShelfStatus') : $t('platformCoupon.offShelfStatus') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('platformCoupon.operation')" align="center" width="240">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openEditCouponModel(scope.row)">
                  {{ $t('platformCoupon.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteCouponModel(scope.row)">
                  {{ $t('platformCoupon.delete') }}
                </el-button>
                <el-button v-if="scope.row.statusCd === '0'" size="mini" type="warning"
                  @click="_openOffShelfCouponModel(scope.row)">
                  {{ $t('platformCoupon.offShelf') }}
                </el-button>
                <el-button v-else size="mini" type="success" @click="_openOnShelfCouponModel(scope.row)">
                  {{ $t('platformCoupon.onShelf') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="couponManageInfo.conditions.page"
            :page-size="couponManageInfo.conditions.row" layout="total, prev, pager, next"
            :total="couponManageInfo.total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-platform-coupon ref="addPlatformCoupon" @refresh="_listCoupons" />
    <edit-platform-coupon ref="editPlatformCoupon" @refresh="_listCoupons" />
  </div>
</template>

<script>
import { listPlatformCoupon, deletePlatformCoupon, shelfPlatformCoupon } from '@/api/coupon/couponApi'
import AddPlatformCoupon from '@/components/coupons/addPlatformCoupon/addPlatformCoupon'
import EditPlatformCoupon from '@/components/coupons/editPlatformCoupon/editPlatformCoupon'

export default {
  name: 'PlatformCouponManage',
  components: {
    AddPlatformCoupon,
    EditPlatformCoupon
  },
  data() {
    return {
      loading: false,
      couponManageInfo: {
        coupons: [],
        total: 0,
        conditions: {
          couponName: '',
          couponType: '',
          // statusCd 必传：空串=全部，'0'=上架中，'1'=已下架；不传后端默认只回在架券
          statusCd: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listCoupons()
  },
  methods: {
    async _listCoupons() {
      this.loading = true
      try {
        const res = await listPlatformCoupon(this.couponManageInfo.conditions)
        // 分页契约：records=页数，total=总数，列表数据取 data，总数取 total
        this.couponManageInfo.coupons = res.data
        this.couponManageInfo.total = res.total
      } catch (error) {
        console.error('获取平台优惠券列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryCouponMethod() {
      this.couponManageInfo.conditions.page = 1
      this._listCoupons()
    },
    _resetCouponMethod() {
      this.couponManageInfo.conditions.couponName = ''
      this.couponManageInfo.conditions.couponType = ''
      this.couponManageInfo.conditions.statusCd = ''
      this.couponManageInfo.conditions.page = 1
      this._listCoupons()
    },
    handleCurrentChange(val) {
      this.couponManageInfo.conditions.page = val
      this._listCoupons()
    },
    switchCouponStatus(status) {
      this.couponManageInfo.conditions.statusCd = status.value
      this.couponManageInfo.conditions.page = 1
      this._listCoupons()
    },
    _openAddCouponModal() {
      this.$refs.addPlatformCoupon.open()
    },
    _openEditCouponModel(row) {
      this.$refs.editPlatformCoupon.open(row)
    },
    _openDeleteCouponModel(row) {
      // 删除为软删除，二次确认后执行
      this.$confirm(this.$t('platformCoupon.confirmDeleteCoupon') + '：' + row.couponName + '？', this.$t('platformCoupon.confirmOperation'), {
        confirmButtonText: this.$t('platformCoupon.confirmDelete'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        await deletePlatformCoupon({ couponId: row.couponId })
        this.$message.success(this.$t('common.deleteSuccess'))
        this._listCoupons()
      }).catch((err) => {
        // 用户取消（cancel/close）静默；业务失败弹出后端 msg
        if (err !== 'cancel' && err !== 'close') {
          this.$message.error(err || this.$t('platformCoupon.operationFail'))
        }
      })
    },
    _openOffShelfCouponModel(row) {
      // 下架二次确认
      this.$confirm(this.$t('platformCoupon.confirmOffShelf'), this.$t('platformCoupon.confirmOperation'), {
        confirmButtonText: this.$t('platformCoupon.confirmDelete'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        await shelfPlatformCoupon({ couponId: row.couponId, state: '1' })
        this.$message.success(this.$t('common.saveSuccess'))
        this._listCoupons()
      }).catch((err) => {
        // 用户取消（cancel/close）静默；业务失败弹出后端 msg
        if (err !== 'cancel' && err !== 'close') {
          this.$message.error(err || this.$t('platformCoupon.operationFail'))
        }
      })
    },
    _openOnShelfCouponModel(row) {
      // 上架二次确认
      this.$confirm(this.$t('platformCoupon.confirmOnShelf'), this.$t('platformCoupon.confirmOperation'), {
        confirmButtonText: this.$t('platformCoupon.confirmDelete'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        await shelfPlatformCoupon({ couponId: row.couponId, state: '0' })
        this.$message.success(this.$t('common.saveSuccess'))
        this._listCoupons()
      }).catch((err) => {
        // 用户取消（cancel/close）静默；业务失败弹出后端 msg
        if (err !== 'cancel' && err !== 'close') {
          this.$message.error(err || this.$t('platformCoupon.operationFail'))
        }
      })
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>
